<template>
  <v-list-item dense :class="[item.new ? 'newcolor' : '', item.changed ? 'changecolor' : '']" @click="$emit('click')">
    <v-list-item-icon class="my-auto mr-0">
      <v-icon v-text="'$supplier_failure_code'" size="16" />
    </v-list-item-icon>
    <v-list-item-content class="py-auto">
      <v-list-item-title>
        <v-container fluid class="pa-0">
          <v-row no-gutters>
            <v-col cols="2" class="mx-3 d-flex align-center primary--text">
              {{ item.Code }}
            </v-col>
            <v-col cols="4" class="d-flex align-center">
              {{ item.Description }}
            </v-col>
            <v-col cols="4" class="d-flex align-center">
              <v-icon size="18" class="mr-2">$supplier</v-icon>
              {{ item.Supplier ? item.Supplier.Name : '' }}
            </v-col>
          </v-row>
        </v-container>
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action class="mr-3">
      <v-badge v-if="item.new || item.changed"
        :content="item.new ? $t('servicesystem.common_objects.commonterms.new') : $t('servicesystem.common_objects.commonterms.changed')"
        :color="item.new ? 'green' : 'orange'" :offset-x="0" :offset-y="10">
      </v-badge>
    </v-list-item-action>
  </v-list-item>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";

export default {
  name: "SupplierFailureCodeListItem",
  props: {
    item: Object,
  },
  components: {
  },
  mixins: [clientAPI],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped></style>